// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"eb8d1d6b","301":"1d95cdd7"}[chunkId] + ".chunk.js";
};